export default "__VITE_ASSET__CRk1R$dE__"